module.exports = __webpack_public_path__ + "static/media/generAouth.2fe88a18.PNG";